import { FLOAT_BUTTON_MIN_VISIBLE_PX } from './float-button.constants'

export const getFloatButtonBounds = ({ width, height }) => ({
  top: FLOAT_BUTTON_MIN_VISIBLE_PX - height,
  left: FLOAT_BUTTON_MIN_VISIBLE_PX - width,
  right: 0,
  bottom: 0,
})

const clampAxis = (value, min, max) => {
  if (!Number.isFinite(value)) {
    return 0
  }
  return Math.min(Math.max(value, min), max)
}

export const clampFloatButtonPosition = (position, viewport) => {
  const { top, left, right, bottom } = getFloatButtonBounds(viewport)
  return {
    x: clampAxis(position?.x, left, right),
    y: clampAxis(position?.y, top, bottom),
  }
}
